export default __webpack_public_path__ + "static/media/aboutShape.332c58f3.png";